import { useState, useEffect } from "react";
import { connect } from "react-redux";
import useForm from '../core/useForm';
import {
    Grid, TextField, Typography, Avatar, Button
} from '@mui/material';
import { withStyles } from '@mui/styles'
import ContactSupport from '@mui/icons-material/ContactSupport';
import ReCAPTCHA from "react-google-recaptcha";
import * as commentAction from "../../actions/comment";
import { AutoRowHeightDataGrid } from "../core/AutoRowHeightDataGrid";

const useStyles = theme => ({
    root: {
        width: 'auto !important',
        backgroundColor: 'white',
        marginTop: theme.spacing(3),
        opacity: '0.85'
    },
    contactForm: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            minWidth: '310px',
        },
        '& .MuiButtonBase-root': {
            margin: theme.spacing(2),
        },
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#f44336!important',
    },
    msgGrid: {
        height: 410,
        width: '100%',
        backgroundColor: "white", 
        marginTop: theme.spacing(3),
        opacity: '0.85'
    }
});

const initialValues = {
    id: 0,
    name: "",
    message: "",
    updatedAt: new Date(),
    createdAt: new Date()
}

const ContactForm = ({ classes, ...props }) => {
    const [pageNo, setPageNo] = useState(0);
    const pageSize = 6;

    useEffect(() => {
        props.fetchAllComments(false, '', pageNo, pageSize);
    }, [pageNo]);

    const handlePageChange = (newPage) => {
        setPageNo(newPage);
    };

    const [isVerified, setIsVerified] = useState(false);

    const validate = (fieldValues = values) => {
        let validationMsg = {};
        if ('name' in fieldValues) {
            validationMsg.name = fieldValues.name ? "" : "This field is required";
        }
        if ('message' in fieldValues) {
            validationMsg.message = fieldValues.message !== null ? "" : "This field is required";
        }

        setErrors({
            ...validationMsg
        });

        if (fieldValues == values) {
            return Object.values(validationMsg).every(x => x == "");
        }
    }

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange } = useForm(initialValues, validate);

    const getDateValue = (params) => {
        switch (params.field) {
            case 'createdAt':
            case 'updatedAt':
                return String(params.value).startsWith('0001-01-01') ? '' : new Date(params.value).toDateString();
            default:
                break;
        }
    }

    const columns = [
        {
            field: 'updatedAt', headerName: 'Updated At', minWidth: 150,
            valueGetter: getDateValue
        },
        { field: 'name', headerName: 'User', minWidth: 150 },
        { field: 'message', headerName: 'Comment', flex: 1, minWidth: 400 },
        { field: 'reply', headerName: 'Reply', flex: 1, minWidth: 400 },
    ];

    const handleCaptachOnChanged = val => {
        setIsVerified(true);
    }

    const handleBtnSubmit = val => {
        if (validate()) {
            props.saveComment(values);
            setValues(initialValues);
            window.grecaptcha.reset();
            setIsVerified(false);
        }
    }

    return (<>
        <Grid container className={classes.root}>
            <form autoComplete="off" noValidate className={classes.contactForm}>
                <Avatar className={classes.avatar}>
                    <ContactSupport />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Contact us
                </Typography>
                <TextField
                    name="name"
                    label="Name"
                    variant="outlined"
                    value={values.name}
                    onChange={handleInputChange}
                    {...(errors.name && { error: true, helperText: errors.name })}
                />
                <TextField
                    name="message"
                    label="Message"
                    variant="outlined"
                    multiline
                    rows={5}
                    value={values.message}
                    onChange={handleInputChange}
                    {...(errors.message && { error: true, helperText: errors.message })}
                />

                <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={handleCaptachOnChanged}
                />

                <div>
                    <Button onClick={handleBtnSubmit} disabled={!isVerified} variant="contained" color="primary">
                        Submit
                    </Button>
                </div>
            </form>
        </Grid>

        <div className={classes.msgGrid}>
            <AutoRowHeightDataGrid rows={props.comments} columns={columns} pageSize={pageSize} disableMultipleSelection rowCount={props.commentCount}
                rowsPerPageOptions={[pageSize]}
                paginationMode="server"
                onPageChange={handlePageChange} 
                // sx={{
                //     '& .MuiDataGrid-cell': {
                //         paddingTop: '5px',
                //         whiteSpace: 'pre-wrap',
                //         overflowY: 'scroll',
                //         textOverflow: 'ellipsis',
                //     }
                // }} 
                />
        </div>
    </>);
}

const mapStateToProps = state => ({
    comments: state.comment.list,
    commentCount: state.comment.total
})

const mapActionToProps = {
    fetchAllComments: commentAction.fetchAll,
    saveComment: commentAction.create,
    updateComment: commentAction.update
}

export default connect(mapStateToProps, mapActionToProps)((withStyles(useStyles))(ContactForm));